<template>
  <div class="product-selector">
    <div class="heading_wrapper">
      <h1>{{ productTitle }}</h1>
      <slot />
      <div class="heading_details__wrapper">
        <customizer-price
          :regPrice="activeVariant.regPr"
          :activePrice="activeVariant.price"
        />
      </div>
    </div>    
    <template v-for="(section, index) in this.customizerConfiguration">
      <customizer-variant-dropdown
        v-if="section.type === 'VARIANT_DROPDOWN'"
        :key="index"
        :value-key="section.key"
        :labelFunction="section.labelFunction"
        :isOpen="sectionStates[index]"
        :displayImage="section.displayImage || false"
        :isThumbnail="section.isThumbnail || false"
        :optionFunction="section.optionFunction"
        :defaultValueFunction="section.defaultValueFunction"
        :valueTypeFunction="section.valueTypeFunction"
        :emptyOptionFunction="section.emptyOptionFunction"
        :activeOptionFunction="section.activeOptionFunction"
        :setFunction="section.setFunction"
        :windowEvent="section.windowEvent"
        @close-dropdown="handleSectionState(index, false)"
        @open-dropdown="handleSectionState(index, true)"
        @option-changed="(e) => bubbleEvent('option-changed', e)"
        :class="`option--${index + 1}`"
      />
      <customizer-qty
        v-else-if="section.type === 'QTY'"
        :key="index"
        :label="section.heading"
        :quantity="quantity"
        @change-qty="handleQuantityChange"
      /> 
      <variable-a-t-c v-else  :key="index" :quantity="quantity"/>
    </template>
  </div>
</template>
<script>
import CustomizerPrice from "./CustomizerPrice.vue";
import CustomizerQty from "./CustomizerQty.vue";
import CustomizerVariantDropdown from "./CustomizerVariantDropdown.vue";
import { mapGetters } from "vuex";
import VariableATC from './VariableATC.vue';
export default {
  components: {
    CustomizerQty,
    CustomizerPrice,
    VariableATC,
    CustomizerVariantDropdown
  },
  name: "VariableController",
  computed: {
    productTitle() {
      const productTitle = this.$store.getters["products/getProductTitle"];
      return productTitle;
    },
    ...mapGetters({
      customizerConfiguration: "customizer/getConfiguration",
      activeProduct: "products/getActiveProduct",
      activeVariant: "products/getActiveVariant",
      activeTimeline: "shipping/getActiveTimeline",
      timelines: "shipping/getTimelines"
    }),
    timelineText() {
      let shippingText = "Made in "
      let weeks = parseInt(this.activeTimeline) / 7
      if (weeks > 0) {
        shippingText += `${Math.ceil(weeks)} Week${weeks > 1 ? 's' : ''}`
      } else {
        shippingText += `${this.activeTimeline} Days`
      }
      return shippingText
    }
  },
  watch: {
    activeVariant(newActive, oldActive) {
      if (newActive.variantId !== oldActive.variantId) {
        this.quantity = 1;
        document.dispatchEvent(new CustomEvent('product-media-changed', {detail: {position: newActive.featured_media.position}}))
      }
    },
  },
  data() {
    return {
      price: 0,
      salePrice: 0,
      quantity: 1,
      sectionStates: [],
    };
  },
  mounted() {
    this.sectionStates = Array(this.customizerConfiguration.length).fill(false);
  },
  methods: {
    bubbleEvent(eventType, e) {
      this.$emit(eventType, e);
    },
    handleSectionState(sectionIndex, isOpen) {
      const stateCopy = [...this.sectionStates];
      stateCopy.forEach((state, index) => {
        if (state && index !== sectionIndex) stateCopy[index] = false;
      });
      stateCopy[sectionIndex] = isOpen;
      this.sectionStates = stateCopy;
    },
    handleQuantityChange(event) {
      if (event.decrement) {
        this.quantity -= 1;
      } else {
        this.quantity += 1;
      }
    },
  },
};
</script>

<style scoped>
.container {
  /* Colors */
  --text-color: #2C2B2A;
  --hover-option-background: #d4d6d9;
  --hover-option-foreground: #000;
  --active-option-background: #000;
  --active-option-foreground: #fff;
  --additional-details-background: #E8EEF0;
  --option-details-background: #FBF6F2;
  --option-details-foreground: #000;
  --border-color: #2C2B2A;
  --button-background: #2C2B2A;
  --button-foreground: #fff;
  --error-background: #fecaca;
  --error-foreground: #991b1b;
  --general-foreground: #000;
  --sale-price-color: #991b1b;
  --detail-background-color: rgba(58, 58, 65, 0.2);
  /* Opacities */
  --hover-opacity: 0.8;
  --disabled-button-opacity: 0.5;
  --modal-overlay-opacity: 0.6;
  /* Misc */
  --border-thickness: 1px;
  --strikethrough-thickness: 2px;
}
.product-selector {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.heading_wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
}
.heading_wrapper h1 {
  margin: 0;
  font-size: 36px;
  font-weight: 400;
  line-height: 120%;
  color: var(--text-color, #2C2B2A);
}
.heading_details__wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.timeline_wrapper {
  color: var(--White, #FFF);
  font-family: Visby;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
  background: var(--Ocean-Teal-100, #8CAAB3);
  padding: 4px 10px;
}
.container >>> .visually-hidden {
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
  position: absolute;
  height: 1px;
  width: 1px;
}
.container >>> .interaction-container {
  display: grid;
  padding: 0;
  -moz-column-gap: 7px;
  column-gap: 7px;
  color: var(--general-foreground);
  grid-template-columns: auto 1fr;
  line-height: 1;
  align-items: start;
  width: 100%;
}
.container >>> label,
.container >>> .label {
  align-items: start;
  color: var(--general-foreground, #000);
  font-family: Visby;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
  color: var(--text-color, #2c2b2a);
  min-width: 85px;
  letter-spacing: 0;
}
.container >>> .interaction-container--half {
  align-items: start;
}
@media screen and (min-width: 1024px) {
  .container >>> .interaction-container {
    grid-template-columns: auto 1fr;
  }
  .container >>> label,
  .container >>> .label {
    font-size: 16px;
  }
  .heading_wrapper h1 {
    font-size: 40px;
  }
  .product-selector {
    row-gap: 15px;
  }
}
</style>
